import Colors from 'assets/Colors';
import styled from 'styled-components';

const BillContainer = styled.div`
  margin: 20px;
  margin-bottom: 105px;
`;
const logoPrint = styled.div`
  display: none;
  @media print {
    display: block;
    position: absolute;
    top: 20px;
    right: 50px;
    opacity: 0.2;
  }
`;

const headerDrawer = styled.div`
  text-align: center;
  margin-top: 41px;
`;
const headerTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
  margin-top: 15px;
`;
const headerInfoCompany = styled.div`
  font-size: 12px;
  font-weight: 300;
  color: ${Colors.text_secondary};
`;
const headerInfoDescrition = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: ${Colors.text_primary};
  margin-top: 15px;
  margin-bottom: 39px;
`;

const subTitleBill = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${Colors.text_primary};
  // margin-bottom: 14px;
  // margin-top: 12px;
`;
const divider = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
  border-top: 1px solid ${Colors.background_dividers};
`;

const contentBill = styled.div`
  display: flex;
  justify-content: center;
`;
const pBill = styled.p`
  font-size: 12px;
  font-weight: 300;
  color: ${Colors.text_primary};
`;

const containerButton = styled.div`
  background: ${Colors.background_secondary};
  box-shadow: -10px 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: end;
  align-items: center;
  height: 89px;
  padding: 0px 31px;
  width: 43.6%;
  z-index: 999999;
  bottom: 0;
  position: fixed;
  padding-right: 100px;
  @media (max-width: 768px) {
    width: 100%;
    padding-right: 0px;
    padding-left: 0px;
    margin: 0 auto;
    justify-content: center;
  }
`;

export default {
  headerDrawer,
  BillContainer,
  contentBill,
  containerButton,
  headerTitle,
  headerInfoCompany,
  headerInfoDescrition,
  subTitleBill,
  pBill,
  divider,
  logoPrint,
};
